module.exports = __webpack_public_path__ + "static/img/basiluofu.0e248ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basiluofu.png
// module id = ciko
// module chunks = 1